<template>
  <footer :class="big">

    <div class="container" >




      <div class="customers-ticker-mob"  v-if="isMobile" >
        <div class="customers-item-mob" v-for="(item, index) in actualArr" :class="'customers-item' + index" >
          <img :src="item.logo" :alt="item.name">
        </div>

      </div>

      <div class="customers-ticker" :class="'numtiems' + actualArr.length" v-if="!big && !isMobile">
        <div class="customers-item" v-for="(item, index) in actualArr" :class="'customers-item' + index" >
          <img :src="item.logo" :alt="item.name">
        </div>

      </div>



      <div v-if="big && !isMobile" class="customers-ticker-big">




        <div class="customers-ticker-big-cont" >
          <div class="customers-item" v-for="(item, index) in customersData" :class="'customers-item' + index" >
            <img :src="item.logo" :alt="item.name">
          </div>
        </div>



      </div>

      <div class="agency-info">

        <div class="agency-info-left">

          <div class="agency-info-partners">
            <div class="agency-info-partners-item agency-info-partners-item1" style="opacity: 0;">
              <div>Duarte Durão</div>
              <div>Managing Partner</div>
            </div>

            <div class="agency-info-partners-item agency-info-partners-item2" style="opacity: 0;">
              <div>Nuno Cardoso</div>
              <div>Creative Partner</div>
            </div>

            <div class="agency-info-partners-item agency-info-partners-item3" style="opacity: 0;">
              <div>Vasco Teixeira-Pinto</div>
              <div>Digital Partner</div>
            </div>

          </div>

          <div class="agency-info-address" style="opacity: 0;">
            <div>Rua Mestre de Aviz 29 - Algés, Oeiras</div>
            <div><span>t </span><a href="tel:215555555" target="_blank"> 21 555 5555</a> &nbsp;&nbsp; <span>e</span><a href="mailto:info@NOSSA.pt" target="_blank"></a> info@NOSSA.pt</div>
          </div>

        </div>
        <div class="agency-info-right"  style="opacity: 0;">

          <div class="agency-info-social">
            <a href="" target="_blank" class="agency-info-social-ico agency-info-social-ico1"><Icons :id="'facebook'"></Icons></a>
            <a href="" target="_blank" class="agency-info-social-ico agency-info-social-ico2"><Icons :id="'linkdin'"></Icons></a>
            <a href="" target="_blank" class="agency-info-social-ico agency-info-social-ico3"><Icons :id="'instagram'"></Icons></a>
            <a href="" target="_blank" class="agency-info-social-ico agency-info-social-ico4"> <Icons :id="'vimeo'"></Icons></a>
            <a href="" target="_blank" class="agency-info-social-ico agency-info-social-ico5"><Icons :id="'behance'"></Icons></a>

          </div>

          <div class="agency-info-pp" v-if="!isMobile">
            <div>Política de Privacidade</div>
            <div> © NOSSA 2021. Todos os direitos reservados</div>
          </div>

        </div>
      </div>


    </div>

    <div class="agency-info-pp" v-if="isMobile">
      <div>Política de Privacidade</div>
      <div> © NOSSA 2021. Todos os direitos reservados</div>
    </div>
  </footer>
</template>

<script>



import {TweenMax} from "gsap/TweenMax";
import {EVENTBUS, WP} from '../../main';
import Icons from "../Modules/Icons";



export default {

  name: 'footer-nossa',
  components: {Icons},
  props: ['actRoute', 'isMobile', 'lang', 'big'],
  data() {
    return {

      loaded: false,
      ready: false,
      customersData: [],
      customersGroups: [],
      actualArr: [],
      actualArrCount: 0,
      pastArr: [],
      newArr: []
    }
  },

  created() {
    const _this = this;
    WP('customers', function (response){

      _this.customersData = _this.getShuffledArr(response);



      // console.log( _this.customersData )

      let countItems = 0;
      let countGroups = 0;
      _this.customersGroups[countGroups] = [];
      for(let i = 0; i < _this.customersData.length; i ++) {

        if(countItems < 6){


        }else {
          countItems = 0;
          countGroups ++;
          _this.customersGroups[countGroups] = [];
        }

        _this.customersGroups[countGroups].push(_this.customersData[i]);
        countItems ++
      }




      _this.loaded = true;

      _this.init();


      // getShuffledArr
    });

  },
  mounted() {

    this.ready = true;
    this.init();
    EVENTBUS.$on('showFooter', this.showFooter);
    //EVENTBUS.$emit('AAA', 0);





  },

  destroyed() {

  },

  methods: {

    init() {
      const _this = this;

      if(_this.loaded && _this.ready){

        _this.getActualArr();



        setTimeout(function(){

          $('.customers-item').css('opacity', 0);

          setTimeout(function(){

            if(_this.big === 'big'){

              $(window).resize(function(){
                _this.resizeMe();
              });

              _this.resizeMe();
              _this.showFooter();
            }

          }, 200);

        }, 10)


      }
    },


    resizeMe() {
      if(this.big === 'big'){
        let refH = window.innerHeight -  $('.agency-info').height() - 50;
        /*



     //   let refItem = ((window.innerWidth * 1.1) + (window.innerHeight * 1.1)) / this.customersData.length;
        let refItem = $('.agency-info').width() / (this.customersData.length / 3);
        let refItemh = $('.agency-info').height() / (this.customersData.length * 0.07);


        $('.customers-item').width(refItem);
        $('.customers-item').height(refItemh);




         */

        $('.customers-ticker-big').height(refH)
      }


    },

    getActualArr(){

      const _this = this;
      //this.actualArrCount

      this.actualArr = this.customersGroups[this.actualArrCount];
    },


    getShuffledArr (arr){
      return [...arr].map( (_, i, arrCopy) => {
        var rand = i + ( Math.floor( Math.random() * (arrCopy.length - i) ) );
        [arrCopy[rand], arrCopy[i]] = [arrCopy[i], arrCopy[rand]]
        return arrCopy[i]
      })
    },


    showFooter(){

      var v = 2
      var d = 0;



      if(!this.big){
        for(let i = 0; i <=5; i++){
          TweenMax.to('.customers-item' + i, v, {delay: d, force3D: true,  opacity: 1, ease:"circ.out"} );
          d += 0.03;
        }
      }else{

        for(let i = 0; i <= this.customersData.length; i++){
          TweenMax.to('.customers-item' + i, v, {delay: d, force3D: true,  opacity: 1, ease:"circ.out"} );
          d += 0.03;
        }
      }


      for(let i = 1; i <=3; i++){
        TweenMax.to('.agency-info-partners-item' + i, v, {delay: d, force3D: true,  opacity: 1, ease:"circ.out"} );
        d += 0.05;
      }

      TweenMax.to('.agency-info-address' , v, {delay: d, force3D: true,  opacity: 1, ease:"circ.out"} );

      d += 0.05;

      TweenMax.to('.agency-info-right' , v, {delay: d, force3D: true,  opacity: 1, ease:"circ.out"} );


      this.changeArr();
    },


    changeArr(){

      const _this = this;

      if(_this.pastArr)



      _this.customersData




      _this.changeArr2();

    },


    changeArr2(){

      const _this = this;



      let elTicker = document.querySelector('.customers-ticker');

      if(_this.isMobile){
        elTicker = document.querySelector('.customers-ticker-mob');
      }


      TweenMax.to(elTicker , 1, {delay: 10, force3D: true,  opacity: 0, ease:"circ.In", onComplete: function(){
          _this.getActualArr();
          TweenMax.to(elTicker, 1, {delay: 0.2, force3D: true,  opacity: 1, ease:"circ.Out", onComplete: function(){
              _this.changeArr();
            }} );

        }} );

    },
  },
};

</script>


// WEBPACK FOOTER //
// src/components/bk/FooterNossaMob.vue